import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const DepoGirisExcel = () => {
    return (
        <>
            <ExcelUpload
                role_name={"depogiris_excel_write"}
                requiredColumnsSase={["sase"]}
                process_type="WAREHOUSE_ENTRY"
                ExcelName={"Depo Giriş Excel"}
                Title={"Depo Giriş Excel"}
                depo={true}
                exampleData={[
                    {
                        "sase": "VF3YEF6F0RMA03711"
                    }
                ]}

            />
        </>
    )
}

export default DepoGirisExcel
